/** Ruta `/perfil` (T057 · US2): datos del administrador, cambio de contraseña y sesiones. */
import { createFileRoute } from '@tanstack/react-router';

import { ProfilePage } from '../../features/profile/profile-page';

export const Route = createFileRoute('/_app/perfil')({
  component: ProfilePage,
});
